(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["gift-wrap-addon"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gift-wrap-addon')) {
    customElements.define('gift-wrap-addon', class GiftWrapAddon extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-gift-wrap-toggle]');
        this.dialog = this.querySelector('[data-gift-wrap-dialog]');
        this.closeButton = this.querySelector('[data-gift-wrap-close]');
        this.variantSelect = this.querySelector('[data-gift-wrap-variant]');
        this.variantInput = this.querySelector('[data-gift-wrap-variant-id]');
        this.price = this.querySelector('[data-gift-wrap-price]');
        this.image = this.querySelector('.gift-wrap-addon__image');
        this.addButton = this.querySelector('.gift-wrap-addon__add');
        this.addButtonLabel = this.querySelector('[data-gift-wrap-add-label]');
        if (!this.toggle || !this.dialog) return;

        this.toggle.addEventListener('change', () => {
          if (this.toggle.checked) this.open();
        });
        this.closeButton?.addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => {
          this.toggle.checked = false;
          document.documentElement.classList.remove('gift-wrap-dialog-open');
        });
        this.variantSelect?.addEventListener('change', () => this.updateVariant());
        document.addEventListener('cart:item-added', (event) => {
          if (String(event.detail?.product?.id) === String(this.variantInput?.value)) {
            this.dialog.close();
          }
        });
      }

      open() {
        document.documentElement.classList.add('gift-wrap-dialog-open');
        this.dialog.showModal();
      }

      updateVariant() {
        const option = this.variantSelect.selectedOptions[0];
        if (!option) return;
        const available = option.dataset.available === 'true';
        this.variantInput.value = option.value;
        this.price.textContent = option.dataset.price;
        this.addButton.disabled = !available;
        this.addButtonLabel.textContent = available
          ? `${this.dataset.addLabel} · ${option.dataset.price}`
          : option.textContent.trim();
        if (this.image && option.dataset.image) {
          const imageUrl = new URL(option.dataset.image, document.baseURI);
          this.image.srcset = [240, 360, 540, 720, 900].map((width) => {
            const source = new URL(imageUrl);
            source.searchParams.set('width', width);
            return `${source.href} ${width}w`;
          }).join(', ');
          this.image.src = imageUrl.href;
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["gm-rating-popover"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gm-rating-popover')) {
  customElements.define('gm-rating-popover', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const opts = {signal:this.abort.signal};
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.stars = this.summary.querySelector('.star-rating');
      this.score = this.stars?.querySelector('span');
      this.originalRating ??= this.stars?.style.getPropertyValue('--star-rating');
      this.originalScore ??= this.score?.textContent;
      this.status = this.querySelector('.gm-rating__status');
      this.link = this.querySelector('.gm-rating__all');
      clearInterval(this.initialPoll);
      let initialAttempts = 0;
      this.initialPoll = setInterval(() => {if(this.updateData() || ++initialAttempts >= 24)clearInterval(this.initialPoll);}, 500);
      this.updateData();
      this.addEventListener('pointerenter', e => {
        clearTimeout(this.leaveTimer);
        if(e.pointerType === 'mouse' && matchMedia('(hover: hover) and (pointer: fine)').matches) this.details.open = true;
      }, opts);
      this.addEventListener('pointerleave', e => {
        if(e.pointerType !== 'mouse')return;
        this.leaveTimer = setTimeout(() => {
          if(!this.querySelector('.gm-rating__panel').contains(document.activeElement))this.close(false);
        }, 250);
      }, opts);
      this.details.addEventListener('toggle', () => {
        clearInterval(this.poll);
        if (!this.details.open) return;
        this.status.textContent = this.status.dataset.loading;
        let attempts = 0;
        const check = () => {
          if (this.updateData() || ++attempts >= 24) {
            clearInterval(this.poll);
            if (attempts >= 24) this.status.textContent = this.status.dataset.unavailable;
          }
        };
        this.poll = setInterval(check, 500);
        check();
      }, opts);
      this.querySelector('.gm-rating__close').addEventListener('click', () => this.close(true), opts);
      document.addEventListener('pointerdown', e => {if (!this.contains(e.target)) this.close(false);}, opts);
      document.addEventListener('focusin', e => {if (!this.contains(e.target)) this.close(false);}, opts);
      this.addEventListener('keydown', e => {if(e.key === 'Escape'){e.preventDefault();this.close(true);}}, opts);
      this.link.addEventListener('click', e => {
        if (!this.widget) return;
        e.preventDefault();
        this.close(false);
        const clear = this.widget.querySelector('.jdgm-histogram__clear-filter');
        if(clear && getComputedStyle(clear).display !== 'none') clear.click();
        const target = this.widget.querySelector('.jdgm-rev-widg__title') || this.widget;
        target.setAttribute('tabindex','-1');
        target.style.scrollMarginTop = '150px';
        target.focus({preventScroll:true});
        target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
      }, opts);
    }
    close(focus) {clearTimeout(this.leaveTimer);if(this.details.open){this.details.open=false;clearInterval(this.poll);if(focus)this.summary.focus();}}
    updateData() {
      const widget = Array.from(document.querySelectorAll('.jdgm-review-widget')).find(el => el.dataset.productId === this.dataset.productId || el.dataset.id === this.dataset.productId);
      if (widget !== this.widget) {
        this.reviewObserver?.disconnect();
        if (widget) {
          this.reviewObserver = new MutationObserver(() => this.updateData());
          this.reviewObserver.observe(widget, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['data-number-of-reviews','data-average-rating','data-frequency']});
        }
      }
      this.widget = widget;
      this.link.hidden = !widget;
      if(widget?.id)this.link.href = '#' + widget.id;
      const source = widget?.querySelector('.jdgm-rev-widg');
      const isSample = /This is a sample review to demonstrate Judge\.me review widget/i.test(source?.textContent || '');
      const hasReviews = Boolean(source?.querySelector('.jdgm-rev'));
      const total = Number(source?.dataset.numberOfReviews);
      const avg = Number(source?.dataset.averageRating);
      const counts = [5,4,3,2,1].map(star => {
        const row = source?.querySelector('.jdgm-histogram__row[data-rating="'+star+'"]');
        return row ? Number(row.dataset.frequency) : NaN;
      });
      const weightedAverage = counts.reduce((sum,n,index)=>sum+n*(5-index),0)/total;
      const valid = !isSample && hasReviews && Number.isInteger(total) && total>0 && Number.isFinite(avg) && avg>=1 && avg<=5 && counts.every(n=>Number.isInteger(n)&&n>=0) && counts.reduce((a,b)=>a+b,0)===total && Math.abs(weightedAverage-avg)<0.011;
      this.querySelector('.gm-rating__data').hidden = !valid;
      this.status.hidden = valid;
      this.link.hidden = !valid;
      this.querySelector('.gm-rating__review-label').hidden = !valid;
      if(!valid){
        if(this.stars)this.stars.style.setProperty('--star-rating',this.originalRating);
        if(this.score)this.score.textContent=this.originalScore;
        if(isSample)this.status.textContent=this.status.dataset.unavailable;
        return false;
      }
      if(this.stars)this.stars.style.setProperty('--star-rating',String(avg));
      if(this.score)this.score.textContent=avg.toFixed(2);
      this.querySelector('[data-summary-total]').textContent=total.toLocaleString(document.documentElement.lang || 'en');
      this.querySelector('.gm-rating__review-label').hidden=false;
      this.querySelector('[data-average]').textContent=avg.toFixed(2);
      this.querySelector('[data-total]').textContent=total.toLocaleString(document.documentElement.lang || 'en');
      this.querySelectorAll('.gm-rating__row').forEach((row,index)=>{
        row.querySelector('[data-count]').textContent=counts[index];
        row.querySelector('meter').value=counts[index]/total*100;
      });
      return true;
    }
    disconnectedCallback(){this.abort?.abort();this.reviewObserver?.disconnect();this.widget=null;clearInterval(this.poll);clearInterval(this.initialPoll);clearTimeout(this.leaveTimer);}
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["halloween-gift-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('halloween-gift-progress')) {
    customElements.define('halloween-gift-progress', class extends HTMLElement {
      setMessage(text) {
        const message = this.querySelector('.halloween-gift-progress__message');
        const label = this.dataset.giftLabel || '';
        const index = label ? text.toLowerCase().indexOf(label.toLowerCase()) : -1;
        if (index < 0) { message.textContent = text; return; }
        const strong = document.createElement('strong');
        strong.textContent = text.slice(index, index + label.length);
        message.replaceChildren(document.createTextNode(text.slice(0, index)), strong, document.createTextNode(text.slice(index + label.length)));
      }
      connectedCallback() {
        this.update = () => this.renderProgress();
        document.addEventListener('DOMContentLoaded', this.update, { once: true });
        window.addEventListener('load', this.update, { once: true });
        this.renderProgress();
        // 局部更新插入自定义元素时，等待本轮 DOM 构建结束，避免子元素尚未就绪。
        queueMicrotask(() => { if (this.isConnected) this.renderProgress(); });
      }
      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.update);
        window.removeEventListener('load', this.update);
      }
      renderProgress() {
        this.hidden = true;
        if (!this.querySelector('.halloween-gift-progress__message') || !this.querySelector('[role="progressbar"]')) return;
        let offer, items;
        try {
          offer = JSON.parse(document.querySelector('[data-golden-ticket-config]')?.textContent || 'null')?.secondaryOffer;
          items = JSON.parse(this.dataset.items);
        } catch { return; }
        // 空购物车仅预加载组件资源，不展示促销进度；加购后使用新组件携带的最新数据。
        if (!Array.isArray(items) || items.length === 0) return;
        if (!offer || offer.id !== 'halloween-spend-109' || offer.enabled !== true || offer.pendingChange ||
            offer.currency !== 'USD' || !Number.isSafeInteger(offer.minimumAmount) || offer.minimumAmount <= 0 || !Array.isArray(items)) return;
        const mode = offer.purchaseScope?.mode || offer.purchaseScopeMode || 'all';
        if (!['all', 'fixed'].includes(mode)) return;
        const products = offer.managedProductIds;
        const variants = offer.qualifyingVariants?.map(item => item.id) || offer.qualifyingVariantIds;
        const ids = Array.isArray(products) && products.length ? products : variants;
        if (mode === 'fixed' && (!Array.isArray(ids) || !ids.every(id => typeof id === 'string' && /^[1-9]\d*$/.test(id)))) return;
        const useProducts = Array.isArray(products) && products.length > 0;
        let total = 0;
        for (const item of items) {
          if (['golden-ticket-buy-two', 'halloween-spend-109'].includes(item.gift) || item.subscription || item.original_price <= 0) continue;
          if (mode === 'fixed' && !ids.includes(String(useProducts ? item.product_id : item.variant_id))) continue;
          if (!Number.isSafeInteger(item.final_line_price) || item.final_line_price < 0) return;
          total += item.final_line_price;
        }
        if (!Number.isSafeInteger(total)) return;
        this.setMessage(this.querySelector('.halloween-gift-progress__message').textContent);
        const currency = this.dataset.currency;
        const rate = currency === 'USD' ? 1 : (this.dataset.baseCurrency === 'USD' ? Number(window.Shopify?.currency?.rate) : NaN);
        if (!(rate > 0)) return;
        const threshold = Math.ceil(offer.minimumAmount * rate);
        if (!Number.isSafeInteger(threshold) || threshold <= 0) return;
        const percentage = Math.min(100, total / threshold * 100);
        const remaining = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Math.max(0, threshold - total) / 100);
        this.setMessage(total >= threshold ? this.dataset.qualified : this.dataset.remaining.replace('[amount]', remaining));
        const track = this.querySelector('[role="progressbar"]');
        track.hidden = false;
        track.setAttribute('aria-valuenow', String(Math.round(percentage)));
        this.style.setProperty('--gift-progress', percentage + '%');
        this.hidden = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search-start"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('desktop-search-panel')) {
    customElements.define('desktop-search-panel', class extends HTMLElement {
      connectedCallback() {
        this.updateHeight = () => {
          if (!this.getClientRects().length) return;
          const top = this.getBoundingClientRect().top;
          this.style.setProperty('--search-available-height', `${Math.max(96, window.innerHeight - top - 12)}px`);
        };
        this.heightObserver = new ResizeObserver(this.updateHeight);
        this.heightObserver.observe(this);
        window.addEventListener('resize', this.updateHeight);
        window.addEventListener('scroll', this.updateHeight, { passive: true });
        this.updateHeight();
      }
      disconnectedCallback() {
        this.heightObserver?.disconnect();
        window.removeEventListener('resize', this.updateHeight);
        window.removeEventListener('scroll', this.updateHeight);
      }
    });
  }
  if (!customElements.get('desktop-search-articles')) {
    customElements.define('desktop-search-articles', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.track = this.querySelector('.header-search-articles');
        this.buttons = this.querySelectorAll('button[data-direction]');
        const update = () => {
          const remaining = this.track.scrollWidth - this.track.clientWidth;
          this.buttons[0].disabled = this.track.scrollLeft <= 2;
          this.buttons[1].disabled = this.track.scrollLeft >= remaining - 2;
        };
        this.buttons.forEach(button => button.addEventListener('click', () => {
          const card = this.track.querySelector('.header-search-article');
          this.track.scrollBy({ left: Number(button.dataset.direction) * (card.getBoundingClientRect().width + 12), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
        }));
        this.track.addEventListener('scroll', update, { passive: true });
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.initialized = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-style5"] && !Shopify.designMode) return;
  try {
    (() => {
		const hoverQuery = window.matchMedia('(min-width: 1068px) and (hover: hover) and (pointer: fine)');
		const boundCurrencyMenus = new WeakSet();
		const boundHelpMenus = new WeakSet();

		const closeCurrencyMenu = (menu) => {
			const button = menu.querySelector('.custom-select--button');
			menu.classList.remove('custom-select--active');
			button?.setAttribute('aria-expanded', 'false');
		};

		const openCurrencyMenu = (menu) => {
			const header = menu.closest('.header.style5');
			header?.querySelectorAll('.thb-header-help[open]').forEach((helpMenu) => helpMenu.removeAttribute('open'));
			menu.classList.add('custom-select--active');
			menu.querySelector('.custom-select--button')?.setAttribute('aria-expanded', 'true');
		};

		const bindCurrencyMenu = (menu) => {
			if (boundCurrencyMenus.has(menu)) return;
			boundCurrencyMenus.add(menu);
			let closeTimer;
			const button = menu.querySelector('.custom-select--button');

			menu.addEventListener('pointerenter', () => {
				if (!hoverQuery.matches) return;
				window.clearTimeout(closeTimer);
				openCurrencyMenu(menu);
			});

			menu.addEventListener('pointerleave', () => {
				if (!hoverQuery.matches) return;
				closeTimer = window.setTimeout(() => {
					if (!menu.matches(':focus-within')) closeCurrencyMenu(menu);
				}, 120);
			});

			button?.addEventListener('click', () => {
				if (!hoverQuery.matches || !menu.matches(':hover')) return;
				window.requestAnimationFrame(() => openCurrencyMenu(menu));
			});
		};

		const openHelpMenu = (menu) => {
			const header = menu.closest('.header.style5');
			header?.querySelectorAll('.thb-desktop-currency custom-select.custom-select--active').forEach(closeCurrencyMenu);
			menu.setAttribute('open', '');
		};

		const bindHelpMenu = (menu) => {
			if (boundHelpMenus.has(menu)) return;
			boundHelpMenus.add(menu);
			let closeTimer;
			const trigger = menu.querySelector('summary');

			menu.addEventListener('pointerenter', () => {
				if (!hoverQuery.matches) return;
				window.clearTimeout(closeTimer);
				openHelpMenu(menu);
			});

			menu.addEventListener('pointerleave', () => {
				if (!hoverQuery.matches) return;
				closeTimer = window.setTimeout(() => {
					if (!menu.matches(':focus-within')) menu.removeAttribute('open');
				}, 120);
			});

			trigger?.addEventListener('click', () => {
				if (!hoverQuery.matches || !menu.matches(':hover')) return;
				window.requestAnimationFrame(() => openHelpMenu(menu));
			});
		};

		const initialize = (root) => {
			root.querySelectorAll('.header.style5 .thb-desktop-currency custom-select').forEach(bindCurrencyMenu);
			root.querySelectorAll('.header.style5 .thb-header-help').forEach(bindHelpMenu);
		};

		if (document.readyState === 'loading') {
			document.addEventListener('DOMContentLoaded', () => initialize(document), { once: true });
		} else {
			initialize(document);
		}

		document.addEventListener('shopify:section:load', (event) => initialize(event.target));
	})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mobile-support-panel"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('mobile-support-panel')) {
    customElements.define('mobile-support-panel', class extends HTMLElement {
      connectedCallback() {
        this.details = this.querySelector('details');
        this.email = this.querySelector('input');
        this.copyButton = this.querySelector('[data-copy-email]');
        this.status = this.querySelector('[role="status"]');
        this.onOutside = event => {
          if (!this.contains(event.target)) this.details.open = false;
        };
        this.onEscape = event => {
          if (event.key === 'Escape' && this.details.open) {
            this.details.open = false;
            this.querySelector('summary').focus();
          }
        };
        this.onCopy = async () => {
          this.copyButton.disabled = true;
          let copied = false;
          try {
            await navigator.clipboard.writeText(this.email.value);
            copied = true;
          } catch {
            this.email.focus();
            this.email.select();
            this.email.setSelectionRange(0, this.email.value.length);
            try { copied = document.execCommand('copy'); } catch {}
          }
          this.status.dataset.success = String(copied);
          this.status.textContent = copied ? `✓ ${this.copyButton.dataset.success}` : this.copyButton.dataset.error;
          this.copyButton.disabled = false;
        };
        this.copyButton.addEventListener('click', this.onCopy);
        document.addEventListener('click', this.onOutside);
        document.addEventListener('keydown', this.onEscape);
      }
      disconnectedCallback() {
        this.copyButton?.removeEventListener('click', this.onCopy);
        document.removeEventListener('click', this.onOutside);
        document.removeEventListener('keydown', this.onEscape);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-campaign-offer"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('gm-campaign-offer')) {
    customElements.define('gm-campaign-offer', class extends HTMLElement {
      connectedCallback() {
        this.copyButton = this.querySelector('[data-copy]');
        this.copyHandler = () => this.copyCode();
        this.copyButton?.addEventListener('click', this.copyHandler);
        this.tick();
        this.interval = window.setInterval(() => this.tick(), 1000);
      }
      disconnectedCallback() {
        window.clearInterval(this.interval);
        window.clearTimeout(this.copyReset);
        this.copyButton?.removeEventListener('click', this.copyHandler);
      }
      async copyCode() {
        const button = this.copyButton;
        const code = this.querySelector('[data-discount-code]')?.textContent.trim();
        const status = this.querySelector('[data-copy-status]');
        if (!button || !code || !status || button.disabled) return;
        button.disabled = true;
        window.clearTimeout(this.copyReset);
        status.textContent = '';
        let copied = false;
        try {
          await navigator.clipboard.writeText(code);
          copied = true;
        } catch (_) {
          const input = document.createElement('textarea');
          input.value = code;
          input.readOnly = true;
          input.style.cssText = 'position:fixed;left:-9999px;top:0;';
          document.body.appendChild(input);
          try { input.select(); copied = document.execCommand('copy'); } catch (_) {}
          finally { input.remove(); button.focus({preventScroll:true}); }
        }
        if (!this.isConnected) return;
        button.disabled = false;
        button.classList.toggle('is-copied', copied);
        button.querySelector('[data-copy-label]').textContent = copied ? button.dataset.success : button.dataset.label;
        status.textContent = copied ? '' : button.dataset.error;
        this.copyReset = window.setTimeout(() => {
          button.classList.remove('is-copied');
          button.querySelector('[data-copy-label]').textContent = button.dataset.label;
          status.textContent = '';
        }, 3000);
      }
      tick() {
        const value = (this.dataset.end || '').trim();
        const match = value.match(/^(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})$/);
        const deadline = match ? Date.parse(`${match[1]}-${match[2]}-${match[3]}T${match[4]}:${match[5]}:${match[6]}+08:00`) : NaN;
        const valid = Number.isFinite(deadline) && new Date(deadline + 28800000).toISOString().slice(0,19).replace('T',' ') === value.replace(/\s+/, ' ');
        const timer = this.querySelector('[data-timer]');
        const expired = this.querySelector('[data-expired]');
        if (!timer || !expired) return;
        if (!valid) { timer.hidden = true; expired.hidden = true; this.hidden = false; return; }
        const remaining = Math.max(0, Math.ceil((deadline - Date.now()) / 1000));
        const isExpired = remaining === 0;
        this.hidden = isExpired && this.dataset.hideExpired === 'true';
        timer.hidden = isExpired;
        expired.hidden = !isExpired;
        if (isExpired) return;
        const values = { days:Math.floor(remaining/86400), hours:Math.floor(remaining%86400/3600), minutes:Math.floor(remaining%3600/60), seconds:remaining%60 };
        for (const [unit, number] of Object.entries(values)) this.querySelector(`[data-unit="${unit}"]`).textContent = String(number).padStart(2,'0');
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
